/* Hearth & Nook Fitness — mega menu + mobile drawer behaviour.
   Markup: snippets/hnf-nav.liquid. No analytics events are fired here —
   opening a menu is not a product view or an add to cart. */
(function () {
  if (window.customElements.get('hnf-mega-nav')) return;

  var OPEN_DELAY = 90;   // hover intent: ignore pointer just passing over the bar
  var CLOSE_DELAY = 220; // grace period for moving from the nav item into the panel
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  class HnfMegaNav extends HTMLElement {
    connectedCallback() {
      this.openItem = null;
      this.timer = null;
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-hnf-item]'));

      this.items.forEach((item) => {
        var btn = item.querySelector('[data-hnf-toggle]');
        if (!btn) return;
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        item._btn = btn;
        item._panel = panel;

        btn.addEventListener('click', () => {
          clearTimeout(this.timer);
          if (this.openItem === item) this.close(); else this.open(item);
        });
        btn.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            this.open(item);
            var first = panel.querySelector('[data-hnf-cat], a');
            if (first) first.focus();
          }
        });

        item.addEventListener('mouseenter', () => {
          if (!canHover.matches) return;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.open(item), this.openItem ? 0 : OPEN_DELAY);
        });
        item.addEventListener('mouseleave', () => {
          if (!canHover.matches) return;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.close(), CLOSE_DELAY);
        });

        var cats = Array.prototype.slice.call(panel.querySelectorAll('[data-hnf-cat]'));
        cats.forEach((cat, i) => {
          var activate = () => this.activate(cats, cat);
          cat.addEventListener('mouseenter', activate);
          cat.addEventListener('focus', activate);
          cat.addEventListener('click', activate);
          cat.addEventListener('keydown', (e) => {
            var next = null;
            if (e.key === 'ArrowDown') next = cats[i + 1] || cats[0];
            if (e.key === 'ArrowUp') next = cats[i - 1] || cats[cats.length - 1];
            if (e.key === 'ArrowRight') {
              var pane = document.getElementById(cat.getAttribute('aria-controls'));
              next = pane && pane.querySelector('a');
            }
            if (next) { e.preventDefault(); next.focus(); }
          });
        });
      });

      this._onKey = (e) => {
        if (e.key === 'Escape' && this.openItem) {
          var btn = this.openItem._btn;
          this.close();
          btn.focus();
        }
      };
      this._onDocClick = (e) => {
        if (this.openItem && !this.contains(e.target)) this.close();
      };
      document.addEventListener('keydown', this._onKey);
      document.addEventListener('click', this._onDocClick);
      this.addEventListener('focusout', (e) => {
        if (this.openItem && e.relatedTarget && !this.contains(e.relatedTarget)) this.close();
      });
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._onKey);
      document.removeEventListener('click', this._onDocClick);
    }

    open(item) {
      if (this.openItem === item) return;
      if (this.openItem) this.close();
      item._panel.hidden = false;
      // next frame so the fade/slide transition runs from the hidden state
      requestAnimationFrame(() => item.classList.add('is-open'));
      item._btn.setAttribute('aria-expanded', 'true');
      this.openItem = item;
    }

    close() {
      var item = this.openItem;
      if (!item) return;
      item.classList.remove('is-open');
      item._panel.hidden = true;
      item._btn.setAttribute('aria-expanded', 'false');
      this.openItem = null;
    }

    activate(cats, active) {
      cats.forEach((c) => {
        var on = c === active;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-expanded', on ? 'true' : 'false');
        var pane = document.getElementById(c.getAttribute('aria-controls'));
        if (pane) pane.hidden = !on;
      });
    }
  }

  class HnfMobileNav extends HTMLElement {
    connectedCallback() {
      this.openBtn = this.querySelector('[data-hnf-mnav-open]');
      this.panel = this.querySelector('.hnf-mnav__panel');
      this.overlay = this.querySelector('.hnf-mnav__overlay');
      if (!this.openBtn || !this.panel) return;
      // The sticky header can clip fixed-position children, so the drawer
      // lives directly under <body>.
      document.body.appendChild(this.overlay);
      document.body.appendChild(this.panel);

      this.openBtn.addEventListener('click', () => this.open());
      this.panel.querySelectorAll('[data-hnf-mnav-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());
      this.panel.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { e.preventDefault(); this.close(); }
        if (e.key === 'Tab') this.trap(e);
      });
      // Close when a link inside is followed (e.g. same-page anchors).
      this.panel.addEventListener('click', (e) => { if (e.target.closest('a')) this.close(true); });
      // If the viewport grows to desktop while open, release the lock.
      window.matchMedia('(min-width: 990px)').addEventListener('change', (mq) => { if (mq.matches) this.close(true); });
    }

    open() {
      this.panel.hidden = false;
      if (this.overlay) this.overlay.hidden = false;
      document.documentElement.classList.add('hnf-scroll-lock');
      this.openBtn.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => {
        this.panel.classList.add('is-open');
        var closeBtn = this.panel.querySelector('.hnf-mnav__close');
        (closeBtn || this.panel).focus();
      });
    }

    close(skipFocus) {
      if (this.panel.hidden) return;
      this.panel.classList.remove('is-open');
      document.documentElement.classList.remove('hnf-scroll-lock');
      this.openBtn.setAttribute('aria-expanded', 'false');
      var done = () => {
        this.panel.hidden = true;
        if (this.overlay) this.overlay.hidden = true;
      };
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) done(); else setTimeout(done, 250);
      if (!skipFocus) this.openBtn.focus();
    }

    trap(e) {
      var f = this.panel.querySelectorAll('a[href], button:not([disabled]), summary');
      var visible = Array.prototype.filter.call(f, (el) => el.offsetParent !== null);
      if (!visible.length) return;
      var first = visible[0];
      var last = visible[visible.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  customElements.define('hnf-mega-nav', HnfMegaNav);
  customElements.define('hnf-mobile-nav', HnfMobileNav);
})();
